<template>
	<el-dialog :visible.sync="dialogVisible" :show-close="false">
		<img class="close-img" src="@/assets/img/images/icon/close-icon.png" @click="dialogVisible = false" />
		<p class="p1">{{ $t('partner.becomeMember') }}</p>
		<p class="p2 mt20">
			{{ $t('partner.memberTips4') }}
		</p>
		<div class="box1 mt20">
			<p class="p2 mt20">
				{{ $t('partner.memberTips5') }}
			</p>
			<p class="mt20">
				<span class="sp1">{{ $t('partner.memberWorth') }}</span>
				<span class="sp2 ml20">100 USDT</span>
			</p>
			<p class="p3 mt8">{{ $t('partner.memberTips6') }}</p>
		</div>
		<el-form class="mt20">
			<el-form-item :label="$t('partner.memberPay')">
				<el-input v-model="joinMemberParam.amount" type="number">
					<template slot="append">USDT</template>
				</el-input>
				<!-- <span>1 RWA ≈ 1 USDT</span> -->
			</el-form-item>
			<el-form-item :label="$t('user_center.account_safe.trade_password.title')">
				<el-input v-model="joinMemberParam.password" type="password" />
			</el-form-item>
		</el-form>
		<div class="btn-box">
			<div class="btn1" @click="dialogVisible = false">{{ $t('google_bind.cancel') }}</div>
			<div class="btn2" @click="joinMember">{{ $t('partner.memberNowPay') }}</div>
		</div>
		<Tips ref="tipsRef" :title="$t('partner.memberTips7')" :text="$t('partner.memberTips8')" />
	</el-dialog>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import Tips from "@/components/Dialog/Tips.vue";
	export default {
		components: {
			Tips,
		},
		data() {
			return {
				dialogVisible: false,
				dkInfo: {
					availableUSDT: 0,
					memberJoinAmount: 0,
					memberJoinDesc: "",
					purchaseMaxAmount: 0,
					purchaseMinAmount: 0,
				},
				joinMemberParam: {
					amount: 100,
					password: "",
				},
			};
		},
		computed: {
			...mapState(["user", "errorCode"]),
		},
		created() {
			if (this.user.vipLevel === "register") {
				this.getDkInfo();
			}
		},
		methods: {
			shouTipsClick() {
				this.$refs.tipsRef.dialogVisible = true;
			},
			//购买点卡（成为会员）相关信息
			getDkInfo() {
				this.$axios.post("/Copartner/QueryDkInfo", {dkType:'normal'}).then((res) => {
					if (null != res.data.data) {
						this.dkInfo = res.data.data;
					}
					this.joinMemberParam.amount = this.dkInfo.memberJoinAmount;
				});
			},
			//成为会员
			joinMember() {
				if(!this.joinMemberParam.password || !this.joinMemberParam.amount) {
					this.$message({
						type: "warning",
						message: this.$t("validate.input_err_tips"),
					});
					this.joinMemberParam.password = "";
					return false;
				}
				if (this.dkInfo.availableUSDT < this.dkInfo.memberJoinAmount) {
					this.$message({
						type: "warning",
						message: this.$t("user_assets.available_not_enough"),
					});
					this.joinMemberParam.password = "";
					return false;
				}
				this.$axios.post("/order/getTranToken", {}).then((res) => {
					this.joinMemberParam.token = res.data.data.token;
					this.$axios
						.post("/Copartner/JoinMember", this.joinMemberParam)
						.then((res) => {
							if (res.data.code === this.errorCode.ok) {
								this.$message({
									type: "success",
									message: this.$t("user_assets.pay_success"),
								});
								this.$store.dispatch("actions_getUserInfo");
								this.dialogVisible = false;
							} else {
								this.$message({
									type: "error",
									message: res.data.innerMsg || res.data.msg,
								});
							}
							this.joinMemberParam.password = "";
						});
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	/deep/.el-dialog {
		width: 540px;
		background: #ffffff;
		border-radius: 10px 10px 10px 10px;

		.el-dialog__header {
			padding: 0;
		}

		.el-dialog__body {
			padding: 32px 30px;
		}

		.el-form-item__label {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
		}

		.el-input-group__append {
			border: none;
			background: rgba(214, 216, 219, 0.3);
			font-family: PingFang SC, PingFang SC;
			font-weight: 800;
			font-size: 16px;
			color: #333333;
		}

		.el-form-item {
			margin-bottom: 0;
		}
	}

	.mt8 {
		margin-top: 8px;
	}

	.p1 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 800;
		font-size: 36px;
		color: #333333;
	}

	.p2 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
	}

	.p3 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #999999;
	}

	.sp1 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 20px;
		color: #333333;
	}

	.sp2 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 800;
		font-size: 32px;
		color: #4063ff;
	}

	.box1 {
		width: 480px;
		height: 160px;
		overflow: hidden;
		padding-left: 20px;
		background: #ffffff;
		background-size: cover;
		background-repeat: no-repeat;
		border-radius: 12px 12px 12px 12px;
		background-image: url(~@/assets/img/images/member-bj.png);
	}

	.close-img {
		width: 14px;
		height: 14px;
		top: 20px;
		right: 20px;
		cursor: pointer;
		position: absolute;
	}

	.btn-box {
		gap: 10px;
		display: flex;
		margin-top: 32px;

		.btn1 {
			flex: 1;
			cursor: pointer;
			height: 48px;
			line-height: 48px;
			text-align: center;
			border-radius: 8px 8px 8px 8px;
			border: 1px solid #4063ff;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 20px;
			color: #4063ff;
		}

		.btn2 {
			flex: 1;
			height: 48px;
			cursor: pointer;
			line-height: 48px;
			text-align: center;
			background: #3370ff;
			border-radius: 8px 8px 8px 8px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 20px;
			color: #ffffff;
		}
	}
</style>